export interface IsMenuItemActiveParams {
  currentPathname: string;
  itemPathname: string;
}

const stripQuery = (pathname: string) => pathname.split('?')[0];

const stripTrailingSlash = (pathname: string) =>
  pathname.length > 1 && pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;

const normalize = (pathname: string) => stripTrailingSlash(stripQuery(pathname));

export const isMenuItemActive = ({ currentPathname, itemPathname }: IsMenuItemActiveParams) => {
  const current = normalize(currentPathname);
  const item = normalize(itemPathname);

  if (!item) {
    return false;
  }

  return current === item || current.startsWith(`${item}/`);
};
